module.exports = __webpack_public_path__ + "media/images/logo_manager-4aa1927793941bf6a5a96e66834e11d2.png";